import { render } from "./ShowCard.vue?vue&type=template&id=4a63d4a9&scoped=true&ts=true"
import script from "./ShowCard.vue?vue&type=script&lang=ts"
export * from "./ShowCard.vue?vue&type=script&lang=ts"

import "./ShowCard.vue?vue&type=style&index=0&id=4a63d4a9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a63d4a9"]])

export default __exports__